import { unauthedV3Request, authedV3Request } from './requests';

/*
 * "Your first event is on us": every endpoint the web flow calls, in one
 * module, so a rails contract change is a one-place edit.
 *
 * Contracts: rails openapi.yaml (PR #1447) for /free_start, /code, /verify and
 * /checkout_session. The rest are ASSUMED pending rails PR B and are listed in
 * the react PR body: the phone ticket, /phone/code, /phone/verify, /account,
 * /phone/resume_link, /resume and GET /plans, plus `resend_after` and the
 * `existing_account` / `phone_required` fields.
 *
 * `utm` is the first-touch utm_* set from the landing URL (Req 7); it rides
 * as top-level fields so rails stores it with the signup ticket.
 */

const post = (path, body) =>
  unauthedV3Request(`v3/${path}`, { method: 'POST', body: JSON.stringify(body) });

export const getFreeStart = () => unauthedV3Request('v3/free_start');

export const postFreeStartCode = ({ email, utm }) =>
  post('free_start/code', { email, ...utm });

export const postFreeStartVerify = ({ email, code, utm }) =>
  post('free_start/verify', { email, code, ...utm });

export const postPhoneCode = ({ signupToken, phone }) =>
  post('free_start/phone/code', { signup_token: signupToken, phone });

export const postPhoneVerify = ({ signupToken, phone, code }) =>
  post('free_start/phone/verify', { signup_token: signupToken, phone, code });

export const postFreeStartAccount = ({ signupToken, firstName, company, utm }) =>
  post('free_start/account', {
    signup_token: signupToken,
    first_name: firstName,
    company: company || undefined,
    ...utm,
  });

export const postResumeLink = ({ signupToken, utm }) =>
  post('free_start/phone/resume_link', { signup_token: signupToken, ...utm });

export const postResume = ({ token }) => post('free_start/resume', { token });

// ASSUMED: `{ plans: [{ plan: "lite"|"plus"|"pro", interval: "month"|"year",
// display_price: "<formatted by rails>" }] }`. Prices come only from here
// (Req 11): read into `{ [plan]: { [interval]: display_price } }`.
export const readPlans = (res) => {
  const out = {};
  ((res && res.plans) || []).forEach(({ plan, interval, display_price: price }) => {
    if (!plan || !interval || !price) return;
    out[plan] = { ...out[plan], [interval]: price };
  });
  return out;
};

export const getPlans = (authToken) =>
  authedV3Request('v3/plans', authToken).then(readPlans);

export const postCheckoutSession = (authToken, { plan, interval }) =>
  authedV3Request('v3/checkout_session', authToken, {
    method: 'POST',
    body: JSON.stringify({ plan, interval }),
  });
